var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppearance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4946 5.85472C27.4946 5.85472 27.8996 4.65472 27.0296 3.81472C26.2346 3.03472 25.1996 3.45472 25.1996 3.45472C24.2846 3.90472 16.5596 8.65972 13.6946 11.8097C12.4046 13.2497 10.6046 17.4947 12.0596 19.0397C13.4396 20.5097 17.9996 18.7847 19.2446 17.5397C22.3346 14.4497 27.0596 6.78472 27.4946 5.85472ZM2.09961 26.9747C5.65461 24.6347 4.28961 21.8597 6.94461 20.0147C8.33961 19.0397 10.2746 19.0847 11.5646 20.4497C12.5096 21.4547 12.7646 24.3047 11.3246 25.6397C8.96961 27.8147 5.32461 27.9647 2.09961 26.9747Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppearance);
export default __webpack_public_path__ + "static/media/appearance.b035ad0765b0108d14c5da9b99401aea.svg";
export { ForwardRef as ReactComponent };